


















import Vue, { PropType } from 'vue';
import Wordcloud from 'vue-wordcloud';
import ChartEmbededTable from './ChartEmbededTable.vue';

export default Vue.extend({
  components: {
    Wordcloud,
    ChartEmbededTable,
  },
  props: {
    wordList: {
      type: Array as PropType<[string, number][]>,
    },
  },
  data(): {
    localWordCloudData: { name: string; value: number }[];
    tableColumns: string[];
    isMounted: boolean;
    isWide: boolean;
  } {
    return {
      localWordCloudData: this.wordList.map((wordEl) => {
        return {
          name: wordEl[0],
          value: wordEl[1],
        };
      }),
      tableColumns: ['단어(상위 50개)', '발생 수'],
      isWide: false,
      isMounted: false,
    };
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.isMounted = true;
    window.dispatchEvent(new Event('resize'));
  },
  methods: {
    onResize() {
      this.isWide =
        this.isMounted &&
        (this.$refs.chartContainer as HTMLDivElement).clientWidth > 1200;
    },
  },
});
